const uri = {
    SIGN_IN: 'signin',
    PO_LIST: 'purchase-list',
    PO_DETAIL: 'purchase-detail',
    RFQ_LIST: 'rfq-list',
    RFQ_DETAIL: 'rfq-detail',
    RFQ_CONFIRM: 'rfq-confirm',
    PURCHASE_PROJECT_LIST: 'purchase-project-list',
    CERTIFICATE_LIST: 'certificate-list',
    CERTIFICATE_DETAIL: 'certificate-detail',
    CERTIFICATE_UPSERT: 'certificate-upsert',
    CERTIFICATE_COMPARE_EFAKTUR_DN: 'certificate-compare-efaktur-dn',
    CERTIFICATE_VALIDATE: 'certificate-validate',
    CERTIFICATE_SUBMIT: 'certificate-submit',
    CERTIFICATE_CANCEL: 'certificate-cancel',
    CERTIFICATE_DRAFT: 'certificate-draft',
    CERTIFICATE_FAKTUR: 'certificate-efaktur',
    CERTIFICATE_DASHBOARD: 'certificate-dashboard',
    PROJECT_LIST: 'project-list',
    PROJECT_SEARCH: 'get-project-search',
    DN_LIST: 'delivery-notes-list',
    DN_DETAIL: 'delivery-notes-detail',
    DN_LIST_SEARCH: 'delivery-notes-search',
    PARTNER_PROFILE: 'partner-profile',
    PARTNER_PROFILE_UPDATE: 'partner-profile-update',
    PROVINCE: 'get-province',
    COUNTRY: 'get-country',
    SERVICE_TYPE: 'get-service-type',
    FORECAST_LIST: 'vendor-forecast-list',
    FORECAST_DETAIL: 'vendor-forecast-detail',
    EVALUATION_LIST: 'vendor-evaluation-list',
    EVALUATION_DETAIL: 'vendor-evaluation-detail',
    QPR_LIST: 'qpr-list',
    QPR_DETAIL: 'qpr-detail',
    QPR_CONFIRM: 'qpr-confirm',
    DELIVERY_LIST: 'daily-delivery-list',
    DELIVERY_DETAIL: 'daily-delivery-detail',
    DOWNLOAD: 'download-printout',
    GET_PO_FROM_DN: 'certificate-get-po-from-dn',
    GET_ATTACHMENT_BINARY: 'get-attachment-binary',
    MESSAGE_LIST: 'messages-list',
    MESSAGE_READ: 'messages-read',
    NOTIFICATION_LIST: 'notifications-list'
}
  
module.exports = uri